import { Bell, Gem, Globe2, Spade, UserPlus } from "lucide-react";
import { Outlet } from "react-router-dom";
import { Link, NavLink } from "./navigation.js";
import { Avatar } from "../art/Avatar.js";
import { useLocale } from "../i18n.js";
import { useSession } from "../net/session.js";
import { usePlayerState } from "./ChannelProvider.js";
import { mobileCopy } from "./mobileCopy.js";
import { TABS } from "./AppShell.js";
import { toWidePath } from "./widePath.js";
import "./wide-shell.css";

export function WideAppShell() {
  const session = useSession();
  const me = session.status === "signedIn" ? session.me : null;
  const { locale } = useLocale();
  // Both shells used to run their own 15-second invite poll, so a signed-in
  // player made two identical requests a minute before counting the one the
  // Friends screen made on top. The badge now reads the channel store.
  const invites = usePlayerState((state) => state.unread);
  const brandLabel = locale === "zh-CN" ? "掼蛋首页" : "Guandan home";


  return (
    <div className="app-frame app-frame-wide wide-shell">
      <aside className="wide-rail">
        <Link className="wide-brand" to="/w" aria-label={brandLabel} title={brandLabel}><Spade aria-hidden="true" /><span>{locale === "zh-CN" ? "掼蛋" : "Guandan"}</span></Link>
        <nav aria-label={locale === "zh-CN" ? "主导航" : "Main navigation"}>
          {TABS.map(({ Icon, ...tab }) => {
            const label = mobileCopy(locale, tab.key);
            return (
              <NavLink key={tab.to} to={toWidePath(tab.to)} end={tab.end} aria-label={label} title={label} className={({ isActive }) => `wide-nav-item${isActive ? " wide-nav-active" : ""}`}>
                <Icon aria-hidden="true" /><span>{label}</span>
              </NavLink>
            );
          })}
        </nav>
        <div className="wide-identity" title={me?.user.displayName}>
          {me && <Avatar avatarId={me.user.avatarId} size={42} />}
          <span><strong>{me?.user.displayName}</strong><small>{me?.progress.rating} {locale === "zh-CN" ? "积分" : "rating"}</small></span>
        </div>
        <div className="wide-rail-actions">
          <span title={locale === "zh-CN" ? "金币" : "Coins"}><Gem aria-hidden="true" /> <b className="tabular">{me?.progress.coins ?? 0}</b></span>
          <Link to="/w/notifications" aria-label={mobileCopy(locale, "notifications")} title={mobileCopy(locale, "notifications")}><Bell aria-hidden="true" />{invites > 0 && <b>{invites}</b>}</Link>

        </div>
      </aside>
      <main className="wide-main"><Outlet /></main>
    </div>
  );
}

export function WideFlowShell() {
  return <div className="wide-flow"><main className="app-frame app-frame-wide"><Outlet /></main></div>;
}

export function WidePublicReplayShell() {
  const { locale, setLocale } = useLocale();
  return (
    <div className="app-frame app-frame-wide wide-public-shell">
      <header>
        <Link to="/w" className="wide-brand"><Spade aria-hidden="true" />{locale === "zh-CN" ? "掼蛋" : "Guandan"}</Link>
        <span>
          <button type="button" onClick={() => setLocale(locale === "zh-CN" ? "en" : "zh-CN")}><Globe2 aria-hidden="true" />{locale === "zh-CN" ? "EN" : "中文"}</button>
          <Link to="/w"><UserPlus aria-hidden="true" />{locale === "zh-CN" ? "注册 / 开始游戏" : "Join / Play"}</Link>
        </span>
      </header>
      <main><Outlet /></main>
    </div>
  );
}
